import { NgIf } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { CartLifeCycle } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

import { FormatUnitPricePipe } from 'src/app/cart/shared/pipes/format-unit-price.pipe';

@Component({
  templateUrl: './column-price-results.component.html',
  styleUrls: ['./column-price-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, AgrI18nSharedModule, FormatUnitPricePipe],
})
export class ColumnPriceResultsComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;
  public cartStatus: CartLifeCycle;
  public cartLifeCycle: typeof CartLifeCycle = CartLifeCycle;
  public initCallback: () => void;

  ngAfterViewInit() {
    this.initCallback();
  }
}
